import { useEffect, useState } from 'react'

interface useInputWrapperProps {
    onFocusHandler: () => void
    onBlurHandler: () => void
    classes: string
}

const useInputWrapper = (
    initialFocusState: boolean,
    disabled: boolean = false,
    error: boolean = false
): useInputWrapperProps => {
    const defaultClass = 'input-wrapper'
    const [focused, setFocused] = useState(initialFocusState)
    const [classes, setClasses] = useState(defaultClass)

    const onFocusHandler = (): void => setFocused(!disabled)
    const onBlurHandler = (): void => setFocused(false)

    const getClasses = (): string => {
        let classes: string[] = [defaultClass]
        if (focused) classes.push('focused')
        if (error) classes.push('error')
        if (disabled) classes.push('disabled')
        return classes.join(' ')
    }

    useEffect(() => {
        if (disabled) setFocused(false)
    }, [disabled])

    useEffect(() => {
        setClasses(getClasses())
    }, [focused, error, disabled])

    return { onFocusHandler, onBlurHandler, classes }
}

export default useInputWrapper
